import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_voyage-squad-3/artifacts/242nersf_final%20llogo.png";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="bg-[#1A1A1A] text-white">
      <div className="max-w-md mx-auto md:max-w-3xl px-5 md:px-8 py-14 md:py-20 flex flex-col items-center">
        <img
          src={LOGO_URL}
          alt="Fourdays"
          className="h-20 md:h-24 w-auto object-contain brightness-125"
        />
        <div className="mt-8 pt-6 border-t border-white/10 w-full flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-[11px] md:text-xs text-white/50">
          <span>© {new Date().getFullYear()} Fourdays</span>
          <span className="hidden sm:inline">·</span>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="hover:text-white transition underline-offset-2 hover:underline"
          >
            Privacy Policy
          </Link>
          <span className="hidden sm:inline">·</span>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:text-white transition underline-offset-2 hover:underline"
          >
            Terms of Service
          </Link>
        </div>
      </div>
    </section>
  );
}
